var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.num != undefined)?_c('span',{style:(_vm.numColor),domProps:{"textContent":_vm._s(_vm.num)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }